import React from "react";
import {
    Button,
    Checkbox,
    Icon,
    IconButton,
    Popover,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    Text,
    VStack,
} from "@chakra-ui/react";
import { FaFilter } from "react-icons/fa";

interface CctvFilterMenuProps {
    showOnline: boolean;
    setShowOnline: (show: boolean) => void;
    showOffline: boolean;
    setShowOffline: (show: boolean) => void;
    handleResetFilters: () => void;
}

const CctvFilterMenu: React.FC<CctvFilterMenuProps> = ({
    showOnline,
    setShowOnline,
    showOffline,
    setShowOffline,
    handleResetFilters,
}) => {
    return (
        <Popover placement="bottom-end">
            <PopoverTrigger>
                <IconButton
                    icon={<Icon as={FaFilter} />}
                    aria-label="Filter Kamera"
                    variant="outline"
                    bg="white"
                />
            </PopoverTrigger>
            <PopoverContent w="300px">
                <PopoverBody>
                    <VStack align="start" spacing={3}>
                        <Text fontWeight="bold" fontSize="sm" mt={2}>Filter Kamera</Text>
                        <Checkbox
                            colorScheme="red"
                            isChecked={showOnline}
                            onChange={(e) => setShowOnline(e.target.checked)}
                        >
                            Kamera Aktif
                        </Checkbox>
                        <Checkbox
                            colorScheme="red"
                            isChecked={showOffline}
                            onChange={(e) => setShowOffline(e.target.checked)}
                        >
                            Kamera Offline
                        </Checkbox>

                        <Button
                            size="sm"
                            colorScheme="red"
                            variant="link"
                            onClick={handleResetFilters}
                            w="full"
                            alignItems="flex-end"
                        >
                            Reset
                        </Button>
                    </VStack>
                </PopoverBody>
            </PopoverContent>
        </Popover>

    );
};

export default CctvFilterMenu;
